// extracted by mini-css-extract-plugin
export default {"AppLayout":"AppLayout_AppLayout__fH0k0","layout":"AppLayout_layout__53UNb","header":"AppLayout_header__hDzBK","footer":"AppLayout_footer__AE6qb"};